import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Field Visit Report")
  ])
], -1)
const _hoisted_2 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "row col-12" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", {
  class: "mt-1",
  style: {"width":"150px"}
}, "Showing data for:", -1)
const _hoisted_9 = {
  key: 0,
  class: "font-weight-bold fs-4"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "select-tranche"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "Visitor Type: ", -1)
const _hoisted_13 = { class: "fs-4" }
const _hoisted_14 = {
  key: 1,
  class: "select-tranche"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, " And Visit Type: ", -1)
const _hoisted_16 = { class: "fs-4" }
const _hoisted_17 = {
  key: 2,
  class: "select-entity"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "And Employee: ", -1)
const _hoisted_19 = { class: "fs-4" }
const _hoisted_20 = {
  key: 3,
  class: "select-entity"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "And Training Partner: ", -1)
const _hoisted_22 = { class: "fs-4" }
const _hoisted_23 = {
  key: 4,
  class: "select-entity"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "And Training Institute: ", -1)
const _hoisted_25 = { class: "fs-4" }
const _hoisted_26 = {
  key: 5,
  class: "select-entity"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "And Visit Date From: ", -1)
const _hoisted_28 = { class: "fs-4" }
const _hoisted_29 = {
  key: 6,
  class: "select-entity"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "And Visit Date To: ", -1)
const _hoisted_31 = { class: "fs-4" }
const _hoisted_32 = {
  key: 7,
  class: "select-entity"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "And Submission Date From: ", -1)
const _hoisted_34 = { class: "fs-4" }
const _hoisted_35 = {
  key: 8,
  class: "select-entity"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "px-2 font-weight-bold fs-4" }, "And Submission Date To: ", -1)
const _hoisted_37 = { class: "fs-4" }
const _hoisted_38 = { class: "row col-12" }
const _hoisted_39 = { class: "col-4 mt-10" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "card mb-5 mb-xl-2" }
const _hoisted_42 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#visitor_type",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_43 = { class: "card-title m-0" }
const _hoisted_44 = { class: "text-dark m-0" }
const _hoisted_45 = {
  id: "visitor_type",
  class: "collapse"
}
const _hoisted_46 = { class: "collapse show" }
const _hoisted_47 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "card mb-5 mb-xl-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#visitor_name",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "text-dark m-0" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Name of Visitors")
    ])
  ])
], -1)
const _hoisted_51 = {
  id: "visitor_name",
  class: "collapse"
}
const _hoisted_52 = { class: "collapse show" }
const _hoisted_53 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "card mb-5 mb-xl-2" }
const _hoisted_56 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity_name",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_57 = { class: "card-title m-0" }
const _hoisted_58 = { class: "text-dark m-0" }
const _hoisted_59 = {
  id: "entity_name",
  class: "collapse"
}
const _hoisted_60 = { class: "collapse show" }
const _hoisted_61 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "card mb-5 mb-xl-2" }
const _hoisted_64 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity_name",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_65 = { class: "card-title m-0" }
const _hoisted_66 = { class: "text-dark m-0" }
const _hoisted_67 = {
  id: "entity_name",
  class: "collapse"
}
const _hoisted_68 = { class: "collapse show" }
const _hoisted_69 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "form-label p-0" }, "Visit Date From ", -1)
const _hoisted_72 = { class: "row" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "form-label p-0" }, "Visit Date To", -1)
const _hoisted_74 = { class: "row" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "form-label p-0" }, "Submission Date From ", -1)
const _hoisted_76 = { class: "row" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "form-label p-0" }, "Submission Date To", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = { class: "row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Visit Type", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_82 = { class: "row mt-3" }
const _hoisted_83 = { class: "col-md-12 dynamic-search" }
const _hoisted_84 = { class: "row mt-3" }
const _hoisted_85 = { class: "col-md-12" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-restore-alt" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_88 = { class: "col-8" }
const _hoisted_89 = { class: "col-md-12 mt-1" }
const _hoisted_90 = { class: "row d-flex" }
const _hoisted_91 = { class: "col-md-6" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("h3", null, "Select Header", -1)
const _hoisted_93 = { class: "card mb-5 mb-xl-2" }
const _hoisted_94 = {
  class: "card-header border-0 cursor-pointer accordion-button bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#header",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_95 = { class: "card-title m-0" }
const _hoisted_96 = { class: "text-dark m-0" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = {
  id: "header",
  class: "collapse"
}
const _hoisted_99 = { class: "collapse show" }
const _hoisted_100 = {
  class: "card-body border-top p-9",
  style: {"overflow":"scroll"}
}
const _hoisted_101 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_102 = { class: "row" }
const _hoisted_103 = ["name", "onUpdate:modelValue", "value"]
const _hoisted_104 = ["for"]
const _hoisted_105 = { class: "col-md-6 mt-8" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_107 = {
  key: 0,
  class: "col-md-12 mt-4"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("h3", null, "Selected Headers", -1)
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = ["onUpdate:modelValue"]
const _hoisted_112 = { class: "row col-12" }
const _hoisted_113 = {
  key: 0,
  class: "row mt-1 w-100 m-0"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_115 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_119 = [
  _hoisted_118
]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = {
  key: 1,
  class: "row"
}
const _hoisted_123 = {
  class: "col-md-12 mt-4",
  id: "dataTable"
}
const _hoisted_124 = { class: "row" }
const _hoisted_125 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_127 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "card mb-5 mb-xl-10",
    key: _ctx.componentKey
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (
                    !_ctx.VisitorTypeLabel.length &&
                    !_ctx.EmployeeName.length &&
                    !_ctx.EntityName.length &&
                    !_ctx.InstituteName.length &&
                    !_ctx.visit_date_from &&
                    !_ctx.visit_date_to &&
                    !_ctx.submission_date_from &&
                    !_ctx.submission_date_to
                  )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " All "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      (_ctx.VisitorTypeLabel)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.VisitorTypeLabel.toString()), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.visit_type)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.visit_type.toString()), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.EmployeeName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.EmployeeName.toString()), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.EntityName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.EntityName.toString()), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.InstituteName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.InstituteName.toString()), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.visit_date_from)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.visit_date_from), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.visit_date_to)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.visit_date_to), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.submission_date_from)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.submission_date_from), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.submission_date_to)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.submission_date_to), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("label", _hoisted_44, [
                          _createElementVNode("span", null, _toDisplayString(this.visitortypes.length) + " Visitor Type", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Visitor Type",
                            modelValue: _ctx.VisitorTypeData,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.VisitorTypeData) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visitorTypeLabelChange(_ctx.VisitorTypeData)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitortypes, (trans) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: trans.id,
                                  label: trans.name,
                                  value: trans.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trans.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Visitor Type",
                            modelValue: _ctx.EmployeeData,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.EmployeeData) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.EmployeeLabelChange(_ctx.EmployeeData)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeList, (trans) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: trans.id,
                                  label: trans.name,
                                  value: trans.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trans.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("label", _hoisted_58, [
                          _createElementVNode("span", null, _toDisplayString(this.entityList.length) + " Name of Training Partner", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Training Partner",
                            modelValue: _ctx.EntityData,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.EntityData) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.EntityLabelChange(_ctx.EntityData)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityList, (trans) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: trans.id,
                                  label: trans.entity_short_name,
                                  value: trans.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trans.entity_short_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("label", _hoisted_66, [
                          _createElementVNode("span", null, _toDisplayString(this.instituteList.length) + " Name of Training Institute", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Training Institute",
                            modelValue: _ctx.InstituteData,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.InstituteData) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.InstituteLabelChange(_ctx.InstituteData)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (trans) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: trans.id,
                                  label: trans.short_name,
                                  value: trans.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trans.short_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createVNode(_component_el_form_item, {
                    prop: "date",
                    class: "mb-3 p-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.visit_date_from,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visit_date_from) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        type: "date",
                        name: "visit_date_from",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createVNode(_component_el_form_item, { class: "mb-3 p-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.visit_date_to,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visit_date_to) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        type: "date",
                        name: "visit_date_from",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createVNode(_component_el_form_item, { class: "mb-3 p-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.submission_date_from,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.submission_date_from) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        type: "date",
                        name: "submission_date_from",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode(_component_el_form_item, {
                    prop: "date",
                    class: "mb-0 p-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.submission_date_to,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.submission_date_to) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        type: "date",
                        name: "submission_date_to",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _hoisted_81,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Visit Type",
                    modelValue: _ctx.visit_type,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.visit_type) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Surprise Visit",
                        value: "Surprise"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Surprise Visit")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Regular Visit",
                        value: "Regular"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Regular Visit")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Inqueray Visit",
                        value: "Inqueray"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Inqueray Visit")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("button", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetData())),
                          type: "button",
                          class: "btn btn-danger p-3 mr-4",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Reset "),
                          _hoisted_86
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getData())),
                          type: "button",
                          class: "btn btn-success p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Search "),
                          _hoisted_87
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("label", _hoisted_96, [
                              (_ctx.headerSelect)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(_ctx.st.length) + " Selected", 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, [
                                _createElementVNode("div", _hoisted_102, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (info) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "form-check",
                                      key: info.key
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        multiple: "",
                                        name: info.name,
                                        "onUpdate:modelValue": ($event: any) => ((info.selected) = $event),
                                        value: {
                                        name: info.name,
                                        key: info.key,
                                      },
                                        class: "form-check-input"
                                      }, null, 8, _hoisted_103), [
                                        [_vModelCheckbox, info.selected]
                                      ]),
                                      _createElementVNode("label", {
                                        class: "form-check-label",
                                        for: info.name
                                      }, _toDisplayString(info.name), 9, _hoisted_104)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("button", {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getData())),
                        type: "button",
                        class: "btn btn-success p-3"
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_106
                      ])
                    ]),
                    (_ctx.showall)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                          _hoisted_108,
                          (_ctx.st.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                _createElementVNode("div", _hoisted_110, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.st, (data, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "col-md-3",
                                      key: index
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "btn btn-primary m-1 py-2 px-2 w-100",
                                        "onUpdate:modelValue": ($event: any) => ((data.name) = $event)
                                      }, null, 8, _hoisted_111), [
                                        [_vModelText, data.name]
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              (_ctx.showTableData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                    _hoisted_114,
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                        title: "Download Xlse",
                        "data-v-54b12dc8": "",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.exportTrainee()))
                      }, _hoisted_117),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                        title: "Download PDF",
                        "data-v-54b12dc8": "",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.downloadPdf()))
                      }, _hoisted_119),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                        title: "Print",
                        "data-v-54b12dc8": "",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.printPdf()))
                      }, _hoisted_121)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showTableData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("div", _hoisted_124, [
                        (_openBlock(), _createElementBlock("div", {
                          key: _ctx.componentTableKey,
                          class: "card-body p-6",
                          "data-v-71816626": "",
                          style: {"border-radius":"1em","border":"2px solid #8dcb8d"}
                        }, [
                          _createElementVNode("div", _hoisted_125, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.tableData,
                              "table-header": _ctx.st,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-type_of_visitor": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.visitor_type?.name), 1)
                              ]),
                              "cell-type_of_visit": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.visit_type), 1)
                              ]),
                              "cell-visiting_officer": _withCtx(({ row: industry }) => [
                                _createElementVNode("b", null, _toDisplayString(industry?.employee?.name), 1),
                                _hoisted_126,
                                _createTextVNode(" " + _toDisplayString(industry?.employee?.designation) + " ", 1),
                                (
                                industry?.employee?.concerned_entity_info
                                  ?.entity_short_name
                              )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_127, "[" + _toDisplayString(industry?.employee?.concerned_entity_info
                                  ?.entity_short_name) + "] -", 1))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(industry?.employee?.concerned_entity_info
                                ?.entity_name), 1)
                              ]),
                              "cell-date_of_visit": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.visited_date ?  _ctx.moment(industry?.visited_date).format(
                                'DD-MM-YYYY'
                              ) : ''), 1)
                              ]),
                              "cell-entity_name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.visited_entity_info?.entity_short_name), 1)
                              ]),
                              "cell-entity_address": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.visited_entity_info?.address), 1)
                              ]),
                              "cell-address": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.visited_institute_address), 1)
                              ]),
                              "cell-report_submission_date": _withCtx(({
                              row: industry,
                            }) => [
                                _createTextVNode(_toDisplayString(industry?.report_of_submission
                                ? _ctx.moment(industry?.report_of_submission).format(
                                    'DD-MM-YYYY'
                                  )
                                : ''), 1)
                              ]),
                              "cell-institute_name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.institute_info?.institute_name), 1)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ]))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}